import digitalAssetsAddToCart from "components/jiffy/digital-assets/digital-assets-add-to-cart/digital-assets-add-to-cart";
import digitalAssetsContinueShoppingModal from "components/jiffy/digital-assets/digital-assets-continue-shopping-modal/digital-assets-continue-shopping-modal";

export default () => {
  const continueShoppingModal = digitalAssetsContinueShoppingModal();
  digitalAssetsAddToCart({
    addedToCart: asset => continueShoppingModal.updateAndShowModal(asset)
  });
};
